import React from "react"
import { Box } from "@mui/material"
import { ButtonLoadingSeeker, IconSeeker } from "@ui-seeker/core"

import { alertsDrawerData, alertsDrawerErrors } from "Pages/ReportsAlerts/Alerts/Conditions/@signals"


export default function AlertsDrawerBaseFooter({ onSubmitAlert, isLoading }) {

	return <Box>
		<ButtonLoadingSeeker
			sx={{ m: 1 }}
			startIcon={<IconSeeker
				icon="circle-left"
				tooltip="Cancel the form content"
			/>}
			onClick={() => alertsDrawerData.value = {}}
			variant="outlined"
		>
			Cancel
		</ButtonLoadingSeeker>
		<ButtonLoadingSeeker
			sx={{ m: 1 }}
			loading={isLoading.value}
			startIcon={<IconSeeker
				icon="cowbell"
				tooltip="Submit the actual form content content"
			/>}
			disabled={!Object.values(alertsDrawerErrors.value).every(a => a)}
			onClick={() => onSubmitAlert(alertsDrawerData.value)}
		>
			Submit
		</ButtonLoadingSeeker>
	</Box>
}